






































import { Component, Watch } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageNames from '@/router/PageNames';
import GeneralLedgerAccountState from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState.vue';
import GeneralLedgerAccountFilterDialog from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountFilterDialog.vue';
import GeneralLedgerAccountCreate from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountCreate.vue';
import GeneralLedgerAccount from '@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccount';

@Component({ name: 'GeneralLedgerAccounts', components: { Alert, GeneralLedgerAccountState, GeneralLedgerAccountFilterDialog, GeneralLedgerAccountCreate }, metaInfo: { title: 'General Ledger Accounts' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.generalLedgerAccounts.fields.name'), sortable: false, width: '40%' },
        { text: this.$t('pageText.generalLedgerAccounts.fields.code'), sortable: false, width: '15%' },
        { text: this.$t('pageText.generalLedgerAccounts.fields.accountType'), sortable: false, width: '15%' },
        { text: this.$t('pageText.generalLedgerAccounts.fields.currency'), sortable: false, width: '15%' },
        { text: this.$t('pageText.generalLedgerAccounts.fields.state'), sortable: false, width: '15%' }
    ];
    generalLedgerAccountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.generalLedgerAccountsPage = +page;
        }
    }

    async beforeMount() {
        await GeneralLedgerAccountsModule.getGeneralLedgerAccounts(this.generalLedgerAccountsPage);
    }

    get generalLedgerAccounts() {
        return GeneralLedgerAccountsModule.generalLedgerAccounts;
    }

    get totalGeneralLedgerAccountsPages() {
        return GeneralLedgerAccountsModule.totalGeneralLedgerAccountsPages;
    }

    get loading() {
        return GeneralLedgerAccountsModule.loadingGeneralLedgerAccounts;
    }

    get pageSize() {
        return GeneralLedgerAccountsModule.pageSize;
    }

    get filterByAccountState() {
        return GeneralLedgerAccountsModule.filterByAccountState;
    }

    @Watch('generalLedgerAccountsPage')
    async onGeneralLedgerAccountsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.generalLedgerAccountsPage}` } });
        // Get new general ledger accounts
        await GeneralLedgerAccountsModule.getGeneralLedgerAccounts(this.generalLedgerAccountsPage);
    }

    async navigateToGeneralLedgerAccount(account: GeneralLedgerAccount) {
        this.$router.push({ name: PageNames.GeneralLedgerAccount, params: { id: account.id }, query: { tab: "0" } });
    }

}
